<!--我的账号-->
<template>
  <div class="userInfoCenter">
    <div class="page-title">我的账号</div>
    <div class="con-box">
      <div class="user-info">
        <div class="img"><i class="el-icon-user-solid"></i></div>
        <p>{{userInfo.enterpriseName}}</p>
      </div>
      <div class="info-list clearfix">
        <div class="fl info-item">
          <div class="title">账号密码<i class="el-icon-success"></i></div>
          <p>初次登录建议修改密码</p>
          <span @click="changePassword()">修改密码&gt;&gt;</span>
        </div>
        <div class="fr info-item">
          <div class="title">绑定邮箱<i class="el-icon-success"></i></div>
          <p>{{userInfo.userEmail}}</p>
          <!-- <span>修改邮箱&gt;&gt;</span> -->
        </div>
      </div>
    </div>
    <change-password ref="changePasswordRef"></change-password>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// 组件
import changePassword from './changePassword.vue'
export default {
  name: 'userInfo',
  components: {
    changePassword
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    console.log(this.userInfo)
  },
  methods: {
    changePassword() {
      this.$refs.changePasswordRef.changePasswordVisible = true
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style lang="less" scoped>
@import './../../styles/common/public.less';
.userInfoCenter{
  .con-box{
    width: 800px;
    height: 300px;
    margin: 10% auto 0;
    .user-info{
      text-align: center;
      .img{
        position: relative;
        width: 120px;
        height: 120px;
        background: @borderColor;
        .borderRadius(50%);
        margin: 2% auto 0;
        i{
          .auto(0);
          line-height: 120px;
          font-size: 45px;
        }
      }
      p{
        margin: 25px 0 45px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .info-list{
      .info-item{
        padding: 20px 17px;
        width: 45%;
        height: 120px;
        border: 1px solid @borderColor;
        background: #fafafa;
        .borderRadius(10px);
        .title{
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: bold;
          color: #000;
          i{
            margin-left: 5px;
            font-size: 16px;
            display: inline-block;
            color: @green;
          }
        }
        p{
          color: @spanColor;
          margin-bottom: 8px;
        }
        span{
          color: @color;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/accountInfoCenter/userInfoCenter.vue